import { useWatch } from 'react-hook-form';
import { CreateEmptySongState } from './CreateEmptySongState';
import { CreateEmptyLibraryState } from './CreateEmptyLibraryState';

export function CreateEmptyState() {
  const type = useWatch({ name: 'type' });

  if (type === 'song') return <CreateEmptySongState />;

  if (type === 'library') return <CreateEmptyLibraryState />;
}
